import Modal from './ModalQuestionYesNo';

export default Modal;
